import Axios from "axios";
import { AsociarFicheroBancoCuentaMovimiento, FicheroControle, FicheroDatos, FicheroFiltro, FicheroRepositorioBorrar, FicheroRepositorioFiltro } from "@/model/Fichero";
import { BaseService } from "./BaseService";

BaseService.loadAxios();

const RESOURCE_NAME = "/fichero";

export class FicheroService {
    public static async grabarFicherosAsync(ficheros: FicheroControle) {
        return await Axios.post(`${RESOURCE_NAME}`, ficheros);
    }

    public static async actualizarFicherosAsync(ficheros: FicheroDatos) {
        return await Axios.put(`${RESOURCE_NAME}`, ficheros);
    }

    public static async deletarFicherosAsync(ficheros: FicheroFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/delete`, ficheros);
    }

    public static async marcarFicherosDefectoAsync(fichero: FicheroFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/defecto`, fichero);
    }

    public static async getFicherosAsync(filtro: FicheroControle) {
        return await Axios.post(`${RESOURCE_NAME}/ficheros`, filtro);
    }

    public static async getFicherosTablasAsync(filtro: FicheroControle) {
        return await Axios.post(`${RESOURCE_NAME}/ficheros/tabla`, filtro);
    }

    public static async downloadFicheroAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/${id}`);
    }


    //#region "Asociar Fichero Movimiento Cuenta"

    public static async getFicherosRepositorioAsync(filtro: FicheroRepositorioFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/repositorio`, filtro);
    }

    public static async asociarFicheroMovimiento(item: AsociarFicheroBancoCuentaMovimiento) {
        return await Axios.post(`${RESOURCE_NAME}/asociar_banco_cuenta_movimiento`,item);
    }

    public static async archivarFicherosAsync(obj: FicheroRepositorioBorrar) {
        return await Axios.post(`${RESOURCE_NAME}/archivar`, obj);
    }

    public static async borrarFicherosAsync(obj: FicheroRepositorioBorrar) {
        return await Axios.post(`${RESOURCE_NAME}/borrar`, obj);
    }

    public static async restaurarFicherosAsync(id: string) {
        return await Axios.put(`${RESOURCE_NAME}/restaurar/${id}`);
    }

    //#endregion

    //#region "Almacenamiento"
    public static async getFicherosAlmacenadosAsync() {
        return await Axios.post(`${RESOURCE_NAME}/almacenamientos`);
    }

    //#endregion

    
}